export default __webpack_public_path__ + "static/manage-your-wallets-mobile-5af9b51b69ceccf5d24100b5999a4540.svg";